import type React from "react";
import type {ContractDetail} from "../contractExplorerTypes.ts";
import {formatMoney, lineName} from "../contractExplorerFormat.ts";
import {Section} from "./Section.tsx";

/** The spend linkage linked to each line of the bundle, largest first. */
export const InContractPurchases: React.FC<{contract: ContractDetail}> = ({contract}) => {
    const purchases = contract.purchases;
    if (!purchases.length) return null;
    const top = Math.max(...purchases.map(p => p.spend), 1);
    return (
        <Section title="In-contract purchases" sub="Linked spend per contract line.">
            <div className="ci-bars">
                {purchases.map(p => (
                    <div key={p.line} className="ci-bar">
                        <span className="ci-bar-l" title={lineName(contract.versions, p.line)}>
                            {p.line && <span className="ci-id">{p.line}</span>} {lineName(contract.versions, p.line)}
                        </span>
                        <span className="ci-bar-t"><span className="ci-bar-f" style={{width: `${Math.max(2, (p.spend / top) * 100)}%`}}/></span>
                        <span className="ci-bar-v">{formatMoney(p.spend, contract.spend_currency)}</span>
                        <span className="ci-bar-n">{p.links} tx</span>
                    </div>
                ))}
            </div>
        </Section>
    );
};
